<template>
    <v-container fluid>
        <div v-if="!loading">    
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Impact of promotion
            </v-row>
            <v-divider />
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    class="tabCell"
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <!--impact tab-->
            <div v-if="impacts?.length" >       
                <v-row v-for="item in impacts"
                    :key="item.id" no-gutters>
                    <v-col class="tabCell text-left">{{ item.team?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ item.spotId }}</v-col>
                    <v-col class="tabCell text-center">{{ item.segment?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ item.trademark?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(item.general_promo) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.targeting, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(item.targeted_promo) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(item.total_promo) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.impact_awareness, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.impact_loyalty, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.impact_fe, 2) }}</v-col>
                    <v-col class="tabCell text-center">{{ formatNumber(item.impact_sales, 2) }}</v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-4"
                justify="center">
                there are no spots impacts yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber, roundNumber } from '../../../functions/common';
export default {
    data() {
        return {
            headers: [
                { title: 'Team', style: 'text-left' },
                { title: 'Spot', style: 'text-center' },
                { title: 'Segment', style: 'text-center' },
                { title: 'Trademark', style: 'text-center' },
                { title: 'General promo', style: 'text-center' },
                { title: 'Targeting', style: 'text-center' },
                { title: 'Targeted promo', style: 'text-center' },
                { title: 'Total promo', style: 'text-center' },
                { title: 'Awareness impact', style: 'text-center' },
                { title: 'Loyalty impact', style: 'text-center' },
                { title: 'FE impact', style: 'text-center' },
                { title: 'Sales impact', style: 'text-center' },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        impacts() {
            return this.$store.getters.spots_impact;
        }
    },
    methods: {
        localeNumber(number) {
            return localeNumber(number, this.locale)
        },
        formatNumber(num, dec) {
            return roundNumber(num, dec);
        }
    },
    components: { Loader }
}
</script>
